var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgCloseSolid = function SvgCloseSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.667 9a8.333 8.333 0 1016.666 0A8.333 8.333 0 00.667 9zm11.869-3.536a.833.833 0 00-1.179 0L9 7.821 6.643 5.464a.833.833 0 10-1.178 1.179L7.822 9l-2.357 2.357a.833.833 0 101.178 1.179L9 10.178l2.357 2.357a.833.833 0 101.179-1.179L10.179 9l2.357-2.357a.833.833 0 000-1.179z"
  })));
};
export default SvgCloseSolid;